<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<i class="fal fa-check theme-color-success text-center" *ngIf="active"></i>
<i class="fal fa-times theme-color-danger text-center" *ngIf="!active"></i>
